module.exports = __webpack_public_path__ + "assets/3e07dd209f0e2ac6b97bea2eb2c85ed8.mp3";